<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "views-administrator-backoffice-players",
  mounted() {
    if (this.$route.name == "AdministratorPlayers") {
      this.$router
        .push({
          name: "AdministratorAccountabilityOnlinePlayersOnlineSearch",
        })
        .catch(() => {});
    }
  },
  watch: {
    $route(val) {
      if (val.name == "AdministratorPlayers") {
        this.$router
          .push({
            name: "AdministratorAccountabilityOnlinePlayersOnlineSearch",
          })
          .catch(() => {});
      }
    },
  },
};
</script>
